import { render } from "./ProductList.vue?vue&type=template&id=a08fdb28&scoped=true&ts=true"
import script from "./ProductList.vue?vue&type=script&lang=ts"
export * from "./ProductList.vue?vue&type=script&lang=ts"

import "./ProductList.vue?vue&type=style&index=0&id=a08fdb28&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a08fdb28"]])

export default __exports__